import type { Question } from './types';

/** 24 reflective prompts, 4 per archetype, in shuffled order. */
export const QUESTIONS: Question[] = [
  // SERVANT
  { id: 's1', archetype: 'servant', prompt: "you find yourself wanting to make someone's life smaller and more comfortable, not larger" },
  { id: 's2', archetype: 'servant', prompt: 'the pleasure of tea poured perfectly, a chore done well, is its own reward' },
  { id: 's3', archetype: 'servant', prompt: 'you would rather be useful than admired' },
  { id: 's4', archetype: 'servant', prompt: 'being told you did it well lands harder than most compliments' },

  // DEVOTEE
  { id: 'd1', archetype: 'devotee', prompt: 'the idea of being on your knees waiting feels more like home than performance' },
  { id: 'd2', archetype: 'devotee', prompt: 'you want the dynamic to feel sacred, not just exciting' },
  { id: 'd3', archetype: 'devotee', prompt: 'ritual language draws you in where casual language slides off' },
  { id: 'd4', archetype: 'devotee', prompt: 'you crave thresholds — ceremonies that mark the dynamic on or off' },

  // SENSUALIST
  { id: 'sn1', archetype: 'sensualist', prompt: 'a hand at your throat would settle you more than a long conversation' },
  { id: 'sn2', archetype: 'sensualist', prompt: 'you are easier to reach through your body than through your words' },
  { id: 'sn3', archetype: 'sensualist', prompt: 'the slow draw of silk, the weight of rope, the sting of a palm — these speak fluently' },
  { id: 'sn4', archetype: 'sensualist', prompt: 'you trust what you feel before you trust what you think' },

  // PRIMAL
  { id: 'p1', archetype: 'primal', prompt: 'you would rather be chased than asked' },
  { id: 'p2', archetype: 'primal', prompt: 'you want a dominant whose body knows what yours does' },
  { id: 'p3', archetype: 'primal', prompt: 'negotiation outside the moment, surrender inside it — that pattern fits you' },
  { id: 'p4', archetype: 'primal', prompt: 'being claimed feels older than being chosen' },

  // BRAT
  { id: 'b1', archetype: 'brat', prompt: 'you want to make him work for it. the chase is the point.' },
  { id: 'b2', archetype: 'brat', prompt: 'soft compliance bores you. the fight is the foreplay.' },
  { id: 'b3', archetype: 'brat', prompt: 'you want a dominant who can hold you without flinching when you push' },
  { id: 'b4', archetype: 'brat', prompt: 'the surrender is sweeter when it has been earned, not given' },

  // LITTLE
  { id: 'l1', archetype: 'little', prompt: 'being cared for in a softer way is something you want more often than you admit' },
  { id: 'l2', archetype: 'little', prompt: 'being told what to wear feels like a gift, not a chore' },
  { id: 'l3', archetype: 'little', prompt: 'the world is heavy. in the right dynamic, you want to put it down.' },
  { id: 'l4', archetype: 'little', prompt: 'tenderness with structure is a flavor you have rarely tasted enough of' },
];

export const QUESTION_COUNT_PER_ARCHETYPE = 4;
